if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {

      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          this.cartNotification.renderContents(response);        
        if(response){

          document.querySelector('.cart-notification-info-parent').style.visibility = 'visible';
          document.querySelector('.remove-item-message').style.display = 'none';
          document.querySelector('#cart-notification').style.display = "block";
          document.querySelector('.cart-noti-shopping-mob').addEventListener('click', function(){
            document.querySelector('#cart-notification').style.display = "none";
            document.querySelector('main').classList.remove('cart-overlay');
          })
          
//         get current item quanity
          
          let current_item_quantity = Number(document.querySelector('.quantity__input').value);
          document.getElementById('current_noti_qty').innerHTML = current_item_quantity;
          
//        get current variant id 
          
          let current_variant_id = document.querySelector('#product_variant_id').value;
          console.log('current_variant_id --> ',current_variant_id)
//         get current price

          let current_price = document.querySelector('.price-item--sale').querySelector('.money').innerHTML.replace(/,/g, '');
          
//           When item variant have diff price it add extra span because of currency converter
          if(current_price.includes('span')){
            var price_parser = new DOMParser();
            var price_doc = price_parser.parseFromString(current_price, 'text/html');
            let price_return_html = price_doc.body;
            let price_main_html = price_return_html.querySelector('span');
            current_price = price_main_html.innerHTML;
          }
          
          if(current_price.includes('Rs')){
            let current_currency = current_price.split('.');
            console.log(current_currency);

            let new_current_currency = current_currency[0];
            console.log(new_current_currency);

            let current_price_only = Number(current_currency[1]);
            console.log(current_price_only);

            let new_current_price_only = `${new_current_currency}: ${(current_price_only * current_item_quantity).toLocaleString()}`;
            console.log(new_current_price_only);

            document.querySelector('#cstm-cart-popup-item-price').innerHTML = new_current_price_only;
          }
          else{

            let current_currency_letters = document.querySelector('span[data-currency]').getAttribute('data-currency')
            console.log(current_currency_letters);

            let new_current_currency = current_price[0];
              console.log(new_current_currency);
              let current_currency = current_price.split(new_current_currency);
              console.log(current_currency);

              let current_price_only = Number(current_currency[1]);
              console.log(current_price_only);

              let new_current_price_only = `${new_current_currency} ${(current_price_only * current_item_quantity).toLocaleString()}`;
              console.log(new_current_price_only);

              document.querySelector('#cstm-cart-popup-item-price').innerHTML = new_current_price_only;
              
              

            
          }
          
          let remove_cart_noti_btn = document.querySelector('.cart-noti-remove-btn');
          
          remove_cart_noti_btn.addEventListener('click', function(){
            
//             get cart items and compare with the popup item
            fetch('/cart.js')
            .then((response)=>{
            	return response.json();
            })
            .then((data)=>{

              let current_cart_items = data.items;
              let popup_item_cart_qty = '';
              let new_popup_item_cart_qty= '';

              for(let i=0; i<current_cart_items.length; i++){
                if(current_cart_items[i].id == current_variant_id){
                	popup_item_cart_qty = current_cart_items[i].quantity;

                  	new_popup_item_cart_qty = popup_item_cart_qty - current_item_quantity;
                  
                  let notiFormData = {
                      'id': current_variant_id,
                      'quantity': new_popup_item_cart_qty
                  };


                  fetch('/cart/change.js', {
                    
                    method: 'POST',
                    body: JSON.stringify(notiFormData),
                    
                    headers: {
                      'Content-Type': 'application/json'
                    }
                    
                  })
                  .then(response => {

                    return response.json();
                  })
                  .then(data =>{

                    document.querySelector('.cart-notification-info-parent').style.visibility = 'hidden';
                    document.querySelector('.remove-item-message').style.display = 'block';
                    if(data.item_count == 0){
                      document.querySelector('.cart-count-bubble').querySelector('span').innerHTML = '';
                      document.querySelector('.show-red-circle').classList.add('hide-red-circle');
                      document.querySelector('.show-red-circle').classList.remove('show-red-circle');

                    }
                    else{
                      document.querySelector('.cart-count-bubble').querySelector('span').innerHTML = data.item_count;
                    }
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
                  
                }

              }


            })

          })
//        Show Checkout btn on cart success

//          desktop 
          document.getElementById('cstm-checkout-btn').classList.remove('no-cstm-checkout');
          document.getElementById('cstm-checkout-btn').classList.add('show-cstm-checkout');
 
//          mob 
          document.getElementById('cstm-checkout-btn-mob').classList.remove('no-cstm-checkout');
          document.getElementById('cstm-checkout-btn-mob').classList.add('show-cstm-checkout');
          
//        Add sku on cart popup
          
          let product_item_sku = document.querySelector('.cstm-variant-sku-code').innerHTML;
          
          document.querySelector('.cart-noti-sku').innerHTML = product_item_sku;
        }
        
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
//       	  alert('test....');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (document.querySelector('.product-form__input.product-size-btns') && document.querySelectorAll('.product-form__input.product-size-btns input:checked') && document.querySelectorAll('.product-form__input.product-size-btns input:checked').length <= 0 && document.querySelector('.product-form__input.product-style-btns') && document.querySelectorAll('.product-form__input.product-style-btns input:checked') && document.querySelectorAll('.product-form__input.product-style-btns input:checked').length <= 0) {
          this.errorMessage.textContent = 'Please Select Size and Style';
        } else if (document.querySelector('.product-form__input.product-size-btns') && document.querySelectorAll('.product-form__input.product-size-btns input:checked') && document.querySelectorAll('.product-form__input.product-size-btns input:checked').length <= 0) {
          this.errorMessage.textContent = 'Please Select Size';
        } else if(document.querySelector('.product-form__input.product-style-btns') && document.querySelectorAll('.product-form__input.product-style-btns input:checked') && document.querySelectorAll('.product-form__input.product-style-btns input:checked').length <= 0) {
          this.errorMessage.textContent = 'Please Select Style';
        } else if(document.querySelector('.product-form__input.product-materialmedium-btns') && document.querySelectorAll('.product-form__input.product-materialmedium-btns input:checked') && document.querySelectorAll('.product-form__input.product-materialmedium-btns input:checked').length <= 0) {
           this.errorMessage.textContent = 'Please Select Material Medium';
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  });
}


// let form_position = document.getElementById('cstm-product-form').getBoundingClientRect();

// console.log('form-position:' + form_position.bottom);
// console.log('body-position:' + document.body.scrollTop);



// function isInViewport(el) {
//     const rect = el.getBoundingClientRect();
//     return (
//         rect.top >= 0 &&
//         rect.left >= 0 &&
//         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//         rect.right <= (window.innerWidth || document.documentElement.clientWidth)

//     );
// }


// const box = document.querySelector('#cstm-product-form');

// document.addEventListener('scroll', function () {
//     const messageText = isInViewport(box) ?
//           document.querySelector('.product-form__buttons').style.display = 'none':
//     	 document.querySelector('.product-form__buttons').style.display = 'block';

// }, {
//     passive: true
// });


// let variant_master_selectors = JSON.parse(document.querySelector('.varinats_master_selector').innerHTML);
// let variant_swatch = document.querySelectorAll('.variant-swatch');
// let current_selected_variant_id = '';

// for(let i=0; i<variant_swatch.length; i++){
//   variant_swatch[i].addEventListener('click', function(){
//   	current_selected_variant_id = variant_swatch[i].closest('.product__info-container').querySelector('#product_variant_id').getAttribute('value'); 
//     console.log(current_selected_variant_id);
//   })
  
// }

// console.log(variant_master_selectors);


let current_product_collection = document.querySelector('.product-secondary-img-main').getAttribute('current_product_collection');
// console.log(current_product_collection);

if(current_product_collection.includes('scarves') || current_product_collection.includes('dupattas') || current_product_collection.includes('tights') || current_product_collection.includes('tank-tops')){
  let selected_swatch_color = '';
  let color_swatch = document.querySelectorAll('.swatch-color');

  // getting selected swatch
  function getSelectedSwatchColor(){
    

    for(let i=0; i<color_swatch.length; i++){
      if(color_swatch[i].checked == true){
//         selected_swatch_color = color_swatch[i].getAttribute('value').replace(/\s/g, '').toLowerCase();
        selected_swatch_color = color_swatch[i].getAttribute('value').toLowerCase();
//         console.log(selected_swatch_color);
      }
    }

  }


  //  gettting secondary images of selected swatch
  function getSelectedSwatchImgs(){
    let flag = true;

    let all_secondary_imgs = document.querySelector('.product-color-btns').closest('.product-page-wrapper').querySelectorAll('.product-secondary-img');

    all_secondary_imgs.forEach((value, index)=>{
      value.style.display = "none";
    });


    //   Show only secondary images
    for(let i=0; i<all_secondary_imgs.length; i++){
      if(all_secondary_imgs[i].getAttribute('alt').toLowerCase() == selected_swatch_color){
        all_secondary_imgs[i].style.display = 'block';

        if (all_secondary_imgs[i].style.display === 'block' && flag)
        {
          all_secondary_imgs[i].click();
          flag = false;
        }

      }

    }

  }

if(document.querySelector('.product-color-btns')){
  let all_secondary_imgs = document.querySelector('.product-color-btns').closest('.product-page-wrapper').querySelectorAll('.product-secondary-img');
  all_secondary_imgs.forEach((value, index)=>{
  	value.style.display = 'none';
  })
  
  // Calling functions on page load
  window.addEventListener('load', function(event) {
    getSelectedSwatchColor();
    getSelectedSwatchImgs();
  });

}

//  Calling functions on swatch click
for(let i=0; i<color_swatch.length; i++){
  color_swatch[i].addEventListener('click', function(){
  	getSelectedSwatchColor();
    getSelectedSwatchImgs();
  });
}

}